export const klarnaTestLink = 'https://eu-assets.playground.klarnaservices.com/learn-more/index.html?showButtons=false&showBackground=true#eyJ0aWVySWQiOjM5MzY0NywibGFuZ3VhZ2UiOiJGUiIsImNvdW50cnkiOiJGUiIsInB1cmNoYXNlQW1vdW50Ijo0MDAwLCJpc1RocmVzaG9sZCI6ZmFsc2UsInBheW1lbnRNZXRob2RJZCI6OSwidHJhY2tlclBhcmFtZXRlcnMiOnsiZCI6ImNyZWRpdC1wcm9tb3Rpb24tYXV0by1zaXplIiwiZyI6IjllYTZmMGIwLTI1ODUtNTE5YS04NjRlLTA5NzE0MDI2ZmJlZCIsImoiOiJhMjMwMDI5NC01NDAzLTQ0YzYtYWExNS0zY2ZmZGM5MjlmMDYiLCJrIjoiODgwYjlkNjItY2RkMi00OGZkLTgwOTItZDk3NjI4MmUyZjNhIiwiYWMiOiJ3ZWIiLCJoIjoiRlIiLCJpIjoiRlIiLCJhYSI6NDAwMH0sInRpZXJIYXNoIjoiNTI3M2ZmM2IxY2ZhODY4MTc4OGI1NGRhYjFiYjg0ZDBkNTRmNDZmZmIwMzBhYjg0OTllNTAwOGE4YzE3ZTNmMiIsImNsaWVudElkIjoiOWVhNmYwYjAtMjU4NS01MTlhLTg2NGUtMDk3MTQwMjZmYmVkIn0=';
export const legalText = 'Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.';
export const floaText = 'Offre de crédit à partir de 200 €. Sous réserve d’acceptation par FLOA. Vous disposez d’un délai de rétractation. Consultez les conditions';
export const floaUrl = 'https://help.fr.shopping.rakuten.net/hc/fr/articles/14547973267218';
export const paypalUrl = 'https://www.paypal.com/fr/webapps/mpp/4x';
export const paymentMethods = [
    {
        cardTypeCode: 210,
        name: 'KLARNA',
        monthlyPayment: 3,
        monthlyPaymentRemaining: 2,
        originalAmount: 383.99,
        totalAmount: 383.99,
        downPayment: 128.0,
        monthlyPaymentAmount: 128.0,
        simulationUrl: klarnaTestLink,
        schedules: [],
    },
    {
        name: 'FLOA',
        monthlyPayment: 10,
        downPayment: 128.0,
        monthlyPaymentAmount: 150.0,
        feesAmount: 50,
        totalAmount: 1073.0,
        simulationUrl: '',
        schedules: [
            {
                amount: 110,
                date: new Date('2023-09-19T00:00:00.000+00:00'),
                rank: 1,
            },
            {
                amount: 107,
                date: new Date('2023-10-19T00:00:00.000+00:00'),
                rank: 2,
            },
            {
                amount: 107,
                date: new Date('2023-11-18T00:00:00.000+00:00'),
                rank: 3,
            },
            {
                amount: 107,
                date: new Date('2023-12-18T00:00:00.000+00:00'),
                rank: 4,
            },
            {
                amount: 107,
                date: new Date('2024-01-17T00:00:00.000+00:00'),
                rank: 5,
            },
            {
                amount: 107,
                date: new Date('2024-02-16T00:00:00.000+00:00'),
                rank: 6,
            },
            {
                amount: 107,
                date: new Date('2024-03-17T00:00:00.000+00:00'),
                rank: 7,
            },
            {
                amount: 107,
                date: new Date('2024-04-16T00:00:00.000+00:00'),
                rank: 8,
            },
            {
                amount: 107,
                date: new Date('2024-05-16T00:00:00.000+00:00'),
                rank: 9,
            },
            {
                amount: 107,
                date: new Date('2024-06-15T00:00:00.000+00:00'),
                rank: 10,
            },
        ],
    },
];
export const paymentMethodKlarna = [
    {
        cardTypeCode: 210,
        name: 'KLARNA',
        monthlyPayment: 3,
        monthlyPaymentRemaining: 2,
        originalAmount: 383.99,
        totalAmount: 383.99,
        downPayment: 128.0,
        monthlyPaymentAmount: 128.0,
        simulationUrl: klarnaTestLink,
    },
];
export const listForBlockFloa = [
    {
        order: 1,
        title: 'Au moment du paiement choisissez FLOA',
    },
    {
        order: 2,
        title: `Saisissez vos coordonnées bancaires, téléchargez votre pièce d’identité et complétez vos informations sur la plateforme sécurisée FLOA.`,
    },
    {
        order: 3,
        title: 'Signez en ligne votre contrat de financement',
    },
    {
        order: 4,
        title: 'Recevez par email votre échéancier. Un email vous sera envoyé.',
    },
];
